import {PAGE_LANDING_PATH} from "../../../router/constants";

export const HEADER_NAVIGATION_ITEMS = [
    {name: 'Landing', path: `${PAGE_LANDING_PATH}#home`},
    {name: 'Features', path: `${PAGE_LANDING_PATH}#features`},
    {name: 'NAFT Token', path: `${PAGE_LANDING_PATH}#naft`},
    /*{name: 'White Paper', href: 'https://d1zjvcsgfckfe5.cloudfront.net/Nafter-Litepaper-V.1.pdf'},*/
    {name: 'Pools', href: 'https://staking.nafter.io'},
];
